import { Button, Col } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import useSessionAPI from '../apis/sessionAPI';
 

const PosCard = ({id, pos_name, phone, session, user_id }) => {
  const navigate = useNavigate();
  const { create } = useSessionAPI();

  // console.log(session);
  const handleNewSession = async () => {
    try {
      let data = {
        point_of_sale_id: id,
        opening_balance: 0,
        opened_by: user_id
      };
      // localStorage.setItem('pos-cashiers-id', JSON.stringify({id: id}));
      const codes = await create(data);
      // const codes = {};
      let pos_session = {
        session_id: codes.session_id ? codes.session_id : null,
        pos_id: id,
        orders: [{status: 'new',
          is_ordered: false,
          is_selected: true,
          customer_id: '',
          receipt_number: codes.receipt_no,
          order_ref: codes.order_no,
          delivery_region_id: '',
          is_refund: false,
          note: '',
          pick_later: false,
          demand_sold: false,
          orderlines: [],
          paymentLines: [],
          createdAt: '',
          user_id: user_id
        }]
      }
      
      localStorage.setItem(`caspian_pos_session`, JSON.stringify(pos_session));
      localStorage.setItem('caspian_pos_cashier', JSON.stringify({id: '', name: '', pin: null}));
      localStorage.setItem('caspian_pos', JSON.stringify({name: pos_name, hotline: phone}));

      navigate('/pos/session/');
    }catch (err) {
      console.log(err);
    }
  }

  const goToSell = () => {
    const session_ = localStorage.getItem('caspian_pos_session');
    let sess = JSON.parse(session_);
    if (sess) {
      sess.session_id = session.id;
      sess.pos_id = id;
      localStorage.setItem('caspian_pos_session', JSON.stringify(sess));
      localStorage.setItem('caspian_pos_cashier', JSON.stringify({id: '', name: '', pin: null}));
      localStorage.setItem('caspian_pos', JSON.stringify({name: pos_name, hotline: phone}));

      navigate('/pos/session/');
    }else {
      let pos_session = {
        session_id: session.id,
        pos_id: id,
        orders: [{status: 'new',
          is_ordered: false,
          is_selected: true,
          customer_id: '',
          receipt_number: '',
          order_ref: '',
          delivery_region_id: '',
          is_refund: false,
          note: '',
          pick_later: false,
          demand_sold: false,
          orderlines: [],
          paymentLines: [],
          createdAt: '',
          user_id: user_id
        }]
      };
      localStorage.setItem('caspian_pos_session', JSON.stringify(pos_session));
      localStorage.setItem('caspian_pos_cashier', JSON.stringify({id: '', name: '', pin: null}));
      navigate('/pos/session/');
    }
  }

  return (
    <Col md={{span: 8}} style={{height: '150px'}} className='m-1 border'>
      <div className='bg-white p-3 h-full flex flex-col justify-between'>
        <div className='mb-3 '>
          <h6 className='font-semibold text-lg'>{pos_name}</h6>
          <span>{session.status}</span>
        </div>
        <div className='bottom'>
          {session.status === undefined || session.status === 'closed_posted' ?
          <Button type='primary' onClick={handleNewSession} size='middle' className='font-semibold bg-[#189aa0] hover-btn'>NEW SESSION</Button>:
          <>
            {(session.opened_by !== null && session.opened_by === user_id) && <>
              <Button type='primary' onClick={goToSell} className='ms-3 font-semibold bg-[#189aa0] hover-btn'>RESUME</Button>
              <Button type='text' className='ms-3 font-semibold text-[#189aa0]'>CLOSE</Button>
            </>}
          </>
          }
        </div>
      </div>
    </Col>
  )
}

export default PosCard;